'use client';

import { MIXPANEL_EVENTS, useMixpanelEvent } from '@/lib/mixpanel';
import { selectIsLoggedIn } from '@/stores/userSessionStore';
import { useEffect, useState } from 'react';
import { VehicleSearchForm } from '@/components/app-home-page/vehicle-search-form';

interface AppHeroProps {
  initialStates?: string[] | null;
  initialVehicleOptions?: Record<string, Record<string, string[]>> | null;
}

export default function AppHero({ initialStates = null, initialVehicleOptions = null }: AppHeroProps) {
  const [showAiAnalysis, setShowAiAnalysis] = useState(false);

  const track = useMixpanelEvent();
  useEffect(() => {
    track(MIXPANEL_EVENTS.HOME_PAGE_VIEWED, { isLoggedIn: selectIsLoggedIn() });
  }, []);

  return (
    <section className="relative bg-[#00B67A] text-white overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#00B67A] to-[#008C5E]" />
      <div className="absolute inset-0 opacity-10 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1IiBoZWlnaHQ9IjUiPgo8cmVjdCB3aWR0aD0iNSIgaGVpZ2h0PSI1IiBmaWxsPSIjZmZmIj48L3JlY3Q+CjxwYXRoIGQ9Ik0wIDVMNSAwWk02IDRMNCA2Wk0tMSAxTDEgLTFaIiBzdHJva2U9IiM4ODgiIHN0cm9rZS13aWR0aD0iMSI+PC9wYXRoPgo8L3N2Zz4=')]" />
      <div className="container mx-auto px-4 py-24 md:py-32 relative">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          <div className="lg:w-1/2 space-y-6 text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              Vehicle Protection. <span className="text-yellow-300">Simplified.</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-100">Compare Plans. Save Money. Drive Confidently.</p>
            {/* <Button
              onClick={() => setShowAiAnalysis(true)}
              className="bg-white text-[#00B67A] hover:bg-gray-100"
              size="lg"
            >
              Try AI Analysis
            </Button> */}
          </div>
          <div className="lg:w-1/2 w-full max-w-md mx-auto lg:max-w-none">
            <div className="bg-white rounded-lg shadow-xl p-6 search-form-container">
              <VehicleSearchForm initialStates={initialStates} initialVehicleOptions={initialVehicleOptions} />
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-full h-[150px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
        >
          <path
            d="M0,32L120,42.7C240,53,480,75,720,74.7C960,75,1200,53,1320,42.7L1440,32L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
            className="fill-white"
          ></path>
        </svg>
      </div>
    </section>
  );
}
